import {
  type DatabaseAction,
  databaseActions,
  type DatabaseState,
  initialDatabaseState
} from '../context';
import { patchChangesNothing } from './sameValue';

// Tab visibility is deliberately not part of this. A tab that is not the
// writer sends its writes to the one that is (database/tabWriter.ts), so a
// background tab's write is no longer a conflict to be dropped.
const computeCanWrite = (state: DatabaseState): boolean =>
  !!state.db && !state.disabled && !state.pendingMigrations;

export const databaseReducer = (
  state: DatabaseState,
  action: DatabaseAction
): DatabaseState => {
  let nextState: DatabaseState;

  switch (action.type) {
    case databaseActions.SET_DB:
      if (state.db === action.payload) return state;
      nextState = { ...state, db: action.payload };
      break;
    case databaseActions.SET_DISABLED:
      if (state.disabled === action.payload) return state;
      nextState = { ...state, disabled: action.payload };
      break;
    case databaseActions.SET_ERROR:
      if (state.error === action.payload) return state;
      return { ...state, error: action.payload };
    case databaseActions.SET_SHOW_POPUP:
      if (state.showPopup === action.payload) return state;
      return { ...state, showPopup: action.payload };
    case databaseActions.SET_IS_INITIALIZING:
      if (state.isInitializing === action.payload) return state;
      return { ...state, isInitializing: action.payload };
    case databaseActions.SET_HASHING_DISABLED:
      if (state.hashingDisabled === action.payload) return state;
      return { ...state, hashingDisabled: action.payload };
    case databaseActions.RESET_STATE:
      return initialDatabaseState;
    case databaseActions.SET_MULTIPLE: {
      if (patchChangesNothing(state, action.payload)) return state;
      nextState = { ...state, ...action.payload };
      break;
    }
    default:
      return state;
  }

  nextState.canWrite = computeCanWrite(nextState);
  return nextState;
};
